import React, { useEffect, useRef, useState } from "react";
import "./projects_indiv.scss";

import { useNavigate, useParams } from "react-router";
import gsap from "gsap";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { getProjectById } from "../../data/ProjectsData";
import Testimonial from "../../components/testmonial/Testimonial";
const ProjectsIndiv = () => {
  const { id } = useParams();

  const nameRef = useRef(null);

  const textRef = useRef(null);
  const [project, setProject] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const project = getProjectById(id);
    if (project === null) {
      navigate("/not-found");
    } else {
      setProject(project);
    }
  }, []);

  useEffect(() => {
    gsap.fromTo(
      nameRef.current,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        scrollTrigger: {
          trigger: nameRef.current,
          start: "top+=100 top", // animation starts after 100px scroll
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: "power4.out" } });

    tl.fromTo(
      textRef.current,
      { y: 10, opacity: 0 }, // start position (100px down)
      { y: 0, opacity: 1, duration: 1, ease: "power2.inOut" } // end position
    );

    tl.fromTo(
      textRef.current,
      { clipPath: "inset(50% 0 50% 0)" }, // start: hidden from center
      {
        clipPath: "inset(0% 0 0% 0)", // end: fully visible
        duration: 1.5,
        ease: "power2.inOut",
      }
    );
  }, []);

  return (
    <div className="projects_indiv_main">
      <div className="projects_indiv_heading">
        <h1 ref={textRef}>{project?.name}</h1>
      </div>
      <div className="projects_indiv_container">
        <div className="projects_indiv_section projects_indiv_section1">
          {window.innerWidth >= 1024 && (
            <div className="projects_indiv_info" ref={nameRef}>
              <span>Name:</span>
              <span>{project?.name}</span>
            </div>
          )}
          {window.innerWidth < 1024 && (
            <div className="projects_indiv_info">
              <span>Name:</span>
              <span>{project?.name}</span>
            </div>
          )}
          <div className="projects_indiv_info">
            <span>Location: </span>
            <span>{project?.location}</span>
          </div>
          <div className="projects_indiv_info">
            <span>Year: </span>
            <span>{project?.year}</span>
          </div>
          <div className="projects_indiv_info">
            <span>Area: </span>
            <span>{project?.area}</span>
          </div>
          <div className="projects_indiv_info">
            <span>Scope: </span>
            <span>Interior Design,Execution </span>
          </div>
          <div className="projects_indiv_info">
            <span>Description:</span>

            <span className="desc">{project?.description}</span>
          </div>
          {project?.testimonialContent && (
            <div className="projects_indiv_info project_indiv_testimonial">
              <span>Testimonial:</span>

              <Testimonial projectId={id} />
            </div>
          )}
        </div>
        <div className="projects_indiv_section projects_indiv_section2">
          <div className="image_grid">
            <PhotoProvider
              maskOpacity={0.9}
              speed={() => 500}
              loop={false}
              easing={(type) =>
                type === 2 ? "cubic-bezier(0.16, 1, 0.3, 1)" : "ease"
              }
            >
              {project?.images?.map((item, index) => (
                <PhotoView key={index} src={item}>
                  <img
                    src={item}
                    alt=""
                    className={`${index % 3 === 0 ? "large" : "small"}`}
                    style={{ cursor: "pointer" }}
                  />
                </PhotoView>
              ))}
            </PhotoProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsIndiv;
